/** @format */

export * from './promotion.module';
